import { create } from 'zustand';

export const useFeatureTravellerStore = create((set) => ({

    features: [],
    setFeatures: (features) => set({ features }),
    selectedFeature: null,
    setSelectedFeature: (selectedFeature) => set({ selectedFeature }),

    travellers: [],
    setTravellers: (travellers) => set({ travellers }),
    selectedTraveller: null,
    setSelectedTraveller: (selectedTraveller) => set({ selectedTraveller }),

    listViewVisibleFeatures: 3,
    listViewVisibleTravellers: 3,
    setListViewVisibleFeatures: (count) => set({ listViewVisibleFeatures: count }),
    setListViewVisibleTravellers: (count) => set({ listViewVisibleTravellers: count }),

    loadedTravellerData: {},
    setLoadedTravellerData: (data) =>
        set((state) => ({
            loadedTravellerData: { ...state.loadedTravellerData, ...data },
        })),
    updateTravellerDetails: (userId, fullData) =>
        set((state) => ({
            loadedTravellerData: {
                ...state.loadedTravellerData,
                [userId]: fullData,
            },
        })),

    favouriteIds: [],
    setFavouriteIds: (ids) => set({ favouriteIds: ids }),
    addFavourite: (id) =>
        set((state) => ({
            favouriteIds: [...new Set([...state.favouriteIds, id])],
        })),
    removeFavourite: (id) =>
        set((state) => ({
            favouriteIds: state.favouriteIds.filter((fid) => fid !== id),
        })),

    clearAll: () => set({
        features: [],
        travellers: [],
        loadedTravellerData: {},
        favouriteIds: [],
    }),
}));
